import * as tslib_1 from "tslib";
import { CHANNEL } from '../../../../constants/channel.constants';
import { BaseChannelCommunicatorService } from '../base-channel-communicator.service';
var PortalPnCnImplService = /** @class */ (function (_super) {
    tslib_1.__extends(PortalPnCnImplService, _super);
    /**
     * Constructor de la clase
     *
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @function initService
     */
    function PortalPnCnImplService() {
        var _this = _super.call(this) || this;
        // tslint:enable:one-line
        /**
         * Identificador del canal de portal pn
         *
         * *Portal pn channel id*
         */
        _this.CHANNEL_ID = CHANNEL.PORTALPN2.CODE;
        _this.initService(true);
        return _this;
    }
    /**
     * Creación de la promesa para la comunicación con portalpn
     *
     * *Promise creation for portalpn communication*
     *
     * @param {string} op
     */
    PortalPnCnImplService.prototype.createPromise = function (op) {
        return new Promise(function (resolve, _reject) {
            var callback = function (event) {
                if (event.data.origin !== CHANNEL.PORTALPN2.NAME ||
                    event.data.op !== op) {
                    return;
                }
                resolve(event.data);
                window.removeEventListener('message', callback);
            };
            window.addEventListener('message', callback);
        });
    };
    /**
     * Llamada a una función Nativa dependiendo del canal
     *
     * *Calls native function depending on the channel*
     *
     * @param {ExternalRequest} request
     */
    PortalPnCnImplService.prototype.postMessageToChannel = function (request) {
        window.parent.postMessage(request, window.location.origin);
    };
    return PortalPnCnImplService;
}(BaseChannelCommunicatorService));
export { PortalPnCnImplService };
